import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";

export const FilterPanel = ({ children, ...props }: BoxProps) => {
  return (
    <Box
      w="100%"
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="10px"
      shadow="sm"
      p={6}
      {...props}
    >
      {children}
    </Box>
  );
};
